
























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  name: 'TableMenu',
  data() {
    return {
      titleMostAccess: 'Most Access Material Category',
      titleMostActive: 'Top 5 Most Active User',
      titleMaterialAccess: 'Most Active Material Access',
      alignCard: 'center',
      fieldsMaterialAccess: [
        { key: 'no' },
        { key: 'category' },
        { key: 'numberAccess' },
      ],
      fieldsUserActive: [
        { key: 'no' },
        { key: 'category' },
        { key: 'title' },
        { key: 'totalViews' },
      ],
      fieldsCategoryMaterials: [
        { key: 'no' },
        { key: 'salesCode' },
        { key: 'salesName' },
        { key: 'position' },
        { key: 'lastAccess' },
        { key: 'totalAccess' },
      ],
    }
  },
})
export default class extends Vue {
  @Prop({}) public PktData
  @Prop({}) public UserData
  @Prop({}) public MaterialAcess: any | undefined
  @Prop({}) public hasSearch: boolean | undefined
}
